<template>
    <div class="main wallet">
        <header class="wallet-head ptm pbw crw">
            <div class="clear wallet-head__menu">
                <div class="right fs2" @click="show = true">提现帐户</div>
            </div>
            <div class="tac fs2">我的余额（元）</div>
            <div class="tac mtn fs5">{{info.balance}}</div>
            <div class="tac mtn">
                <van-button size="small" @click="applyshow = true">提现</van-button>
            </div>
            <div class="tac mtm fs1">全部提现手续费：{{info.poundage}}元 <van-icon name="warn" /></div>
            <div class="tac mtn fs1">累计收益：{{info.income}}元</div>
        </header>
        <van-tabs v-model="active">
            <van-tab :title="'账单明细'">
                <bill-card v-for="(item,index) in billlist" :key="index" :bill="item"></bill-card>
                <div v-if="!billlist || billlist==''" class="tac c9 bcw ptw pbw">
                    <!-- <i class="iconfont">&#xe646;</i><br/> -->
                    暂无记录
                </div>
                <div v-if="billlist!=''" class="tac c9 bcw ptm pbw" @click="loadBill()" v-show="loadBillShow">{{loadTxt}}</div>               
            </van-tab>
            <van-tab :title="'提现记录'">
                <withdraw-card v-for="(item,index) in withdrawlist" :key="index" :bill="item"></withdraw-card>
                <div v-if="!withdrawlist || withdrawlist==''" class="tac c9 bcw ptw pbw">
                    <!-- <i class="iconfont">&#xe646;</i><br/> -->
                    暂无记录
                </div>
                <div v-if="withdrawlist!=''" class="tac c9 bcw ptm pbw" @click="loadWithdraw()" v-show="loadWithdrawShow">{{loadTxt}}</div> 
            </van-tab>
        </van-tabs>
        <!-- 设置账户 -->
        <van-dialog
        v-model="show"
        title="设置提现账户"
        show-cancel-button
        :before-close="beforeClose"
        >
        <van-field class="mtm"
            v-model="account"
            label="支付宝账号："
            placeholder="请输入支付宝账号"
        />
        <van-field
            v-model="realname"
            label="真实姓名："
            placeholder="请输入真实姓名"
        />
        </van-dialog>
        <!-- 提现 -->
        <van-dialog
        v-model="applyshow"
        title="提现申请"
        disabled-text="以下地址超出配送范围"
        show-cancel-button
        :before-close="withdraw"
        >
        <van-field class="mtm"
            v-model="account"
            label="支付宝账号："
            placeholder="请输入支付宝账号"
            
        />
        <van-field
            v-model="realname"
            label="真实姓名："
            placeholder="请输入真实姓名"
            
        />
        <van-field
            v-model="price"
            v-on:input="watchNum"
            @keydown="handleInput2"
            type="number"
            label="提现金额："
            placeholder="请输入金额"
        />
        <div v-if="this.price>info.balance" class="van-cell fs1 ptn red">输入金额超过零钱余额</div>
        <div v-else>
            <div class="van-cell c9 fs1 ptn pb0">当前可提现余额{{info.balance}}元，<span class="blue" @click="withdrawFull">全部提现</span></div>  
            <div v-if="this.price != ''" class="van-cell red fs1 pt0">手续费：{{poundage}}元（费率{{info.poundage_rate}}%）</div> 
        </div>
        
        </van-dialog>

    </div>
</template>
<script>
import Vue from 'vue';
import { Tab, Tabs,Button,Toast,Dialog,List } from 'vant';
import BillCard from '@/components/BillCard';
import WithdrawCard from '@/components/WithdrawCard';
Vue.use(Tab).use(Tabs).use(Button).use(Toast).use(Dialog).use(List);
export default {
    inject:['reload'],  //注入reload方法
    name: 'Wallet',
    components: {
        BillCard,WithdrawCard
    },
    data(){
        return {
            info:{}, //账户信息
            billlist:[], // 账单明细
            withdrawlist:[], // 账单明细
            show: false,
            applyshow: false,
            account: '',
            realname: '',
            price:'',
            active:'',//tab标签索引
            poundage:'', //手续费
            pageBill: 1,
            pageWithdraw:1,
            loadBillShow:true,
            loadWithdrawShow:true,
            pageSize: 15,
            loadTxt:'加载更多'
        }
    },
    created(){
        // 账户信息
        this.$http.get('club_account/getAccountInfo').then(res => {
            this.info = res.data.value      
            this.account = res.data.value.account     
            this.realname = res.data.value.realName     
        })
        //账单明细
        this.getBillList()
        //提现记录
        this.getWithdrawList()
    },
    methods: {
        beforeClose(action, done) {
            //设置账户            
            if (action === 'confirm') {
                this.$http.post('club_account/setAccount',{
                    account:this.account,
                    realName:this.realname
                }).then(res => {
                    if(!res.data.code){
                        Toast.success('设置成功！')
                        setTimeout(done, 500)
                    }else{
                        Toast.fail(res.data.message)
                        setTimeout(done, 500)
                    }                                   
                })
                
            } else {
                done();
            }
        },
        withdrawFull(){
            //全部提现
            this.price = this.info.balance-this.info.poundage  //提现金额
            // this.poundage = (this.info.balance*this.info.poundage_rate/100).toFixed(2)//全部提现的手续费  
            this.poundage = this.info.poundage//全部提现的手续费  
        },
        withdraw:function(action, done){
            var _this = this;
            var priceTotal = (Number(this.price*100)+Number(this.poundage*100))/100;  //输入金额和手续费之和  解决小数相加损失精度问题            
            // console.log(priceTotal)
            if (action === 'confirm') {
                if(this.price>this.info.balance){
                    Toast.fail({
                        message:'超出本次可提现金额！',
                        duration:1000
                    })
                    setTimeout(done(false), 500)
                }else if(priceTotal>this.info.balance){
                    //超出提现余额                    
                    Dialog.confirm({
                        message: '剩余零钱不足以支付提现手续费￥'+this.poundage+'，当前最大可提现金额为￥'+(this.info.balance-this.info.poundage)+'，是否要全部提现？'
                    }).then(() => {
                        // on confirm
                        this.$options.methods.withdrawFull.bind(this)();  //调用methods方法
                    }).catch(() => {
                        // on cancel
                    });
                    setTimeout(done(false), 500)
                }else{
                    //  console.log(priceTotal)
                    //  console.log(this.info.balance)
                    // 是否全部提现
                    if(priceTotal==this.info.balance){
                        var all = 'all'
                        var pricenumber = this.info.balance 
                    }else{
                        var all =''
                        var pricenumber = this.price
                    }
                    // 提现
                    this.$http.post('club_account/withdraw',{
                        account:this.account,
                        realName:this.realname,
                        amount:pricenumber,
                        type:all
                    }).then(res => {
                        if(!res.data.code){
                            setTimeout(done, 500)
                            _this.reload()
                            // _this.active = 1
                        }else{
                            Toast.fail({
                                message:res.data.message,
                                duration:1000
                            })                        
                            setTimeout(done(false), 500)
                        }                 
                    })
                }
            } else {
                done();
            }
        },
        watchNum:function(e){
            // e = (e.match(/^\d*(\.?\d{0,2})/g)[0]) || null

            //监听input框的金额
            this.poundage = (this.price*this.info.poundage_rate/100).toFixed(2)  //实时手续费
        },
        handleInput2(e) {
            // 通过正则过滤小数点后两位
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null    
        },
        loadBill(){
            //加载更多：账单明细
            this.loadTxt='正在加载'
            this.pageBill++
            this.getBillList()
        },
        getBillList(){
            // console.log(this.pageBill)
            //获取账单明细
            this.$http.get('club_account/getBillList?page='+this.pageBill+'&limit='+this.pageSize).then(res => {
                // console.log(res)
                if(!res.data.code){
                    let re = res.data.value  
                    this.billlist = this.billlist.concat(re.list) 
                    this.loadTxt='加载更多' 
                    if(re.list.length < this.pageSize){
                        this.loadBillShow = false
                    }
                }else{
                    Toast.fail(res.data.message)
                    this.loadTxt='加载更多'
                }
                      
            })
        },
        loadWithdraw(){
            //加载更多：提现记录
            this.loadTxt='正在加载'
            this.pageWithdraw++
            this.getWithdrawList()
        },
        getWithdrawList(){
            // console.log(this.pageWithdraw)
            //获取提现记录
            this.$http.get('club_account/getWithdrawList?page='+this.pageWithdraw+'&limit='+this.pageSize).then(res => {
                if(!res.data.code){
                    let re = res.data.value  
                    this.withdrawlist = this.withdrawlist.concat(re.list) 
                    this.loadTxt='加载更多' 
                    if(re.list.length < this.pageSize){
                        this.loadWithdrawShow = false
                    }
                }else{
                    Toast.fail(res.data.message)
                    this.loadTxt='加载更多'
                }
                      
            })
        }
    },
    // computed: {
    //     computPoundage: function () {
    //         if(this.all==true){
    //             return this.info.balance*this.info.poundage_rate/100
    //         }else{
    //             return this.price*this.info.poundage_rate/100
    //         }
            
    //     }
    // }
    
}
</script>
<style lang="less">
.wallet{
    padding-bottom:0;
    & .van-tab--active{
        color:#FF6600;
    }
    & .van-tabs__line{
        background-color: #FF6600;
    }
    &-head{
        background-color: #FF6600;
        &__menu{
            padding-right: .15rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Wallet.vue